import { desktopCSS, tabletCSS } from '@measures/responsive'
import { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'

interface DateProps {
  isPinned: boolean
  children?: ReactNode
}

const StyledDate = styled.div<DateProps>`
  ${({
    theme: {
      colors: {
        grey: { grey_80 },
      },
      fonts: { sourceSansPro },
    },
    isPinned,
  }) => css`
    box-sizing: border-box;
    color: ${grey_80};
    font-family: ${sourceSansPro};
    line-height: 20px;
    text-align: left;
    font-size: 14px;
    margin: 16px 0 0 0;

    ${tabletCSS(css`
      padding: 0 10px 0 ${isPinned ? '10px' : '0'};
    `)}

    ${desktopCSS(css`
      padding: 0 10px 0 ${isPinned ? '10px' : '0'};
    `)}
  `}
`

const Date: FunctionComponent<DateProps> = ({ children, isPinned }) => (
  <StyledDate isPinned={isPinned}>{children}</StyledDate>
)

export default Date
